import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

import classes from "./inventory.module.scss";

import { hasPermission } from "@/services/Utils";

const InventoryFunctionsSelect = ({ handleShow, setTypePrint, handleGlobalStolen, handleGlobalDelete }) => {
	const { permissions } = useSelector((state) => state.inventory);

	return (
		<Row className={classes.actions}>
			<Col className={classes.actionRow} md={12}>
				<div className={classes.label}>Seleccione una opción</div>

				<div
					className={`${classes.optionButton} ${classes.printEmpty}`}
					onClick={(e) => {
						setTypePrint("selected");
						handleShow(e, true);
					}}
				>
					<span>
						<div>Imprimir envases</div>
						seleccionados{" "}
					</span>
				</div>

				<div
					className={`${classes.optionButton} ${classes.printEmpty}`}
					onClick={(e) => {
						setTypePrint("selected_lot");
						handleShow(e, true);
					}}
				>
					<span>
						<div>Imprimir lotes</div>
						seleccionados{" "}
					</span>
				</div>

				<div className={`${classes.optionButton} ${classes.deleteInventory}`} onClick={() => handleGlobalStolen()}>
					<span>
						<div>Marcar robados</div> los envases seleccionados{" "}
					</span>
				</div>

				{hasPermission("delete", permissions) && (
					<div className={`${classes.optionButton} ${classes.deleteInventory}`} onClick={() => handleGlobalDelete()}>
						<span>
							<div>Eliminar</div> envases seleccionados{" "}
						</span>
					</div>
				)}
			</Col>
		</Row>
	);
};

export default InventoryFunctionsSelect;
